import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { LeftArrow } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import isFunction from 'utils/function';

import SvgButton from 'components/CustomButtons/SvgButton';

import { ICON_SIZE } from '../styles';
import styles from './styles';

const ARROW_ICON_SIZE = {
    width: 16,
    height: 16,
};

type Props = {
    onPress: () => void;
    isUpArrow?: boolean;
    disabled?: boolean;
    testID?: string;
};

function ScrollArrow({
    onPress,
    isUpArrow = false,
    disabled = false,
    testID = '',
}: Props) {
    const { t } = useTranslation();

    const {
        ACCESSIBILITY: {
            ARROWS: {
                ACCESSIBILITY_WEB_UP_ARROW,
                ACCESSIBILITY_WEB_DOWN_ARROW,
            },
        },
    } = LANGUAGE_KEYS;

    const onArrowPress = useCallback(() => {
        if (isFunction(onPress)) {
            onPress();
        }
    }, [onPress]);

    const handleKeyDownCapture = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
        }
    }, []);

    return (
        <SvgButton
            accessible
            accessibilityLabel={
                isUpArrow
                    ? t(ACCESSIBILITY_WEB_UP_ARROW)
                    : t(ACCESSIBILITY_WEB_DOWN_ARROW)
            }
            style={[
                ICON_SIZE,
                isUpArrow ? styles.arrowUp : styles.arrowDown,
                disabled && styles.arrowDisabled,
                // @ts-ignore
                { outline: 'none' },
            ]}
            Svg={LeftArrow}
            onPress={onArrowPress}
            onKeyDownCapture={handleKeyDownCapture}
            svgStyle={ARROW_ICON_SIZE}
            tabIndex={-1}
            testID={testID}
            disabled={disabled}
        />
    );
}

export default ScrollArrow;
